import * as React from "react";
const RecoverSales = (props) => (
  <svg
    width={34}
    height={33}
    viewBox="0 0 34 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_di_6515_3803)">
      <g clipPath="url(#clip0_6515_3803)">
        <rect x={1} width={32} height={32} rx={10} fill="#27272A" />
        <g clipPath="url(#clip1_6515_3803)" filter="url(#filter1_dd_6515_3803)">
          <path
            d="M26.5995 25.5999H24.9995C24.9978 24.1152 24.4073 22.6918 23.3575 21.6419C22.3076 20.5921 20.8842 20.0015 19.3995 19.9999H15.5355V25.1311L8.10113 17.6967C7.65119 17.2466 7.39844 16.6362 7.39844 15.9999C7.39844 15.3635 7.65119 14.7531 8.10113 14.3031L15.5355 6.86865V11.9999H19.3995C21.3084 12.002 23.1386 12.7612 24.4884 14.111C25.8382 15.4608 26.5974 17.2909 26.5995 19.1999V25.5999Z"
            fill="url(#paint0_linear_6515_3803)"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_di_6515_3803"
        x={0.5}
        y={0}
        width={33}
        height={33}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.5} />
        <feGaussianBlur stdDeviation={0.25} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6515_3803"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_6515_3803"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.5} />
        <feGaussianBlur stdDeviation={0.25} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_6515_3803"
        />
      </filter>
      <filter
        id="filter1_dd_6515_3803"
        x={-22.5996}
        y={-19.7016}
        width={79.1992}
        height={79.2}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={10} />
        <feGaussianBlur stdDeviation={10} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6515_3803"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={3.89851} />
        <feGaussianBlur stdDeviation={15} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_6515_3803"
          result="effect2_dropShadow_6515_3803"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_6515_3803"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_6515_3803"
        x1={7.25008}
        y1={3.02001}
        x2={20.7217}
        y2={23.2614}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0.65} />
      </linearGradient>
      <clipPath id="clip0_6515_3803">
        <rect x={1} width={32} height={32} rx={10} fill="white" />
      </clipPath>
      <clipPath id="clip1_6515_3803">
        <rect
          width={19.2}
          height={19.2}
          fill="white"
          transform="translate(7.40039 6.3999)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default RecoverSales;
